export enum ApiKeysStateEnum {
  Revoked = 'Revoked',
  Active = 'Active',
  Pending = 'Pending',
  Inactive = 'Inactive'
}
